module.exports = __webpack_public_path__ + "static/media/bottom-arrow.1eb90e73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bottom-arrow.svg
// module id = 239
// module chunks = 0